<div
    data-cy="custom-gauge-graph"
    echarts
    [options]="echartsOptions"
    [extentions]="echartsExtentions"
    (chartInit)="onChartInit($event)"
></div>
<div
    *ngIf="inCustomEditMode"
    class="delete-icon-container"
    (click)="removeItem(); $event.stopPropagation()"
>
    <mat-icon svgIcon="delete" class="delete-icon" />
</div>
<div data-cy="custom-gauge-graph-title" class="title">
    {{ channel.opsData.name }}
</div>
